module.exports = {
	"ha": "bc",
	"id": 5.4,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2018 Q1",
		"lastYear": "2018",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginLeft": 90,
			"marginTop": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 5.4</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by MSM Status, Year Ending 2018 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -125,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 97.96814936847886,
						"dataLabels": {
							"enabled": true,
							"format": "3568"
						}
					},
					{
						"y": 88.02855573860516,
						"dataLabels": {
							"enabled": true,
							"format": "3206"
						}
					},
					{
						"y": 83.55299286106535,
						"dataLabels": {
							"enabled": true,
							"format": "3043"
						}
					},
					{
						"y": 79.65403624382208,
						"dataLabels": {
							"enabled": true,
							"format": "2901"
						}
					},
					{
						"y": 70.78528281164196,
						"dataLabels": {
							"enabled": true,
							"format": "2578"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.77236338322311,
						"dataLabels": {
							"enabled": true,
							"format": "2809"
						}
					},
					{
						"y": 87.33031674208145,
						"dataLabels": {
							"enabled": true,
							"format": "2509"
						}
					},
					{
						"y": 82.17890706578488,
						"dataLabels": {
							"enabled": true,
							"format": "2361"
						}
					},
					{
						"y": 74.27775844065437,
						"dataLabels": {
							"enabled": true,
							"format": "2134"
						}
					},
					{
						"y": 56.978767838496346,
						"dataLabels": {
							"enabled": true,
							"format": "1637"
						}
					},
					{
						"y": null
					},
					{
						"y": 82.46687054026503,
						"dataLabels": {
							"enabled": true,
							"format": "3236"
						}
					},
					{
						"y": 56.29459734964322,
						"dataLabels": {
							"enabled": true,
							"format": "2209"
						}
					},
					{
						"y": 51.80937818552498,
						"dataLabels": {
							"enabled": true,
							"format": "2033"
						}
					},
					{
						"y": 47.935779816513765,
						"dataLabels": {
							"enabled": true,
							"format": "1881"
						}
					},
					{
						"y": 40.4434250764526,
						"dataLabels": {
							"enabled": true,
							"format": "1587"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -2.031850631521137,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.1457399103139,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.084217092950716,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.666447584620437,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.13409169251982,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.2276366167768846,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.679957280170882,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.898764447987248,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.614570097416353,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.289597000937214,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -17.533129459734965,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -31.736711990111242,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.967406066093252,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.476635514018692,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.629984051036683,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "MSM<br>n=3642"
			},
			{
				"x": 9,
				"text": "Non-MSM<br>n=2873"
			},
			{
				"x": 15,
				"text": "Unknown<br>n=3924"
			}
		],
		"dataTable": {
			"MSM": [
				3642,
				3568,
				3206,
				3043,
				2901,
				2578
			],
			"Non-MSM": [
				2873,
				2809,
				2509,
				2361,
				2134,
				1637
			],
			"Unknown": [
				3924,
				3236,
				2209,
				2033,
				1881,
				1587
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_4.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_5_4.json
// module id = 167
// module chunks = 0